import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import Icofont from 'react-icofont';
import { formatProductDisplay } from '../../utils.js';

class CheckoutItem extends Component {
  constructor(props) {
    super(props);
    this.loadExtras = this.loadExtras.bind(this);
    this.state = {
      quantity: this.props.qty || 1,
      show: this.props.show || true,
      max: this.props.maxValue || 40,
      min: this.props.minValue || 0,
      extras: [],
      extrasTotal: 0,
      zusaetze: [],
      zusaetzeTotal: 0,
      currentUnitPrice: this.props.price,
      currentSizeLabel: null,
    };

    this.addQty = this.addQty.bind(this);
    this.removeQty = this.removeQty.bind(this);
    setTimeout(() => {
      this.loadExtras();
    }, 100);
  }

  getTotalPrice() {
    const unit = this.state.currentUnitPrice != null ? this.state.currentUnitPrice : this.props.price;
    const productTotal = unit * this.state.quantity;
    return (productTotal + this.state.extrasTotal + this.state.zusaetzeTotal).toFixed(2);
  }

  getTotalPfandPrice() {
    const pfand = this.props.product.getPricePfand?.() || 0;
    return (pfand * this.state.quantity).toFixed(2);
  }

  addQty() {
    this.setState((prevState) => ({ quantity: prevState.quantity + 1 }));
  }

  setQty(amount) {
    this.setState({ quantity: amount });
  }

  removeQty() {
    this.setState((prevState) => ({ quantity: prevState.quantity - 1 }));
  }

  IncrementItem = () => {
    if (this.state.quantity < this.state.max - 2) {
      this.props.addFun(this.props.product);
      this.setState((prevState) => ({ quantity: prevState.quantity + 1 }));
    }
  };

  DecreaseItem = () => {
    if (this.state.quantity > this.state.min) {
      this.setState((prevState) => ({ quantity: prevState.quantity - 1 }), () => {
        if (this.state.quantity === 0) {
          this.props.deleteFun(this.props.product);
        } else {
          this.props.removeFun(this.props.product);
        }
      });
    }
  };

  ToggleClick = () => {
    this.setState((prevState) => ({ show: !prevState.show }));
  };

  loadExtras() {
    const lastRestaurant = JSON.parse(localStorage.getItem("last-restaurant") || "{}");
    if (Object.keys(lastRestaurant).length === 0) return;

    const products = JSON.parse(localStorage.getItem(`restaurant-products-${lastRestaurant.id}`) || "{}");
    if (Object.keys(products).length === 0) return;

    const saved = products[this.props.itemName];
    if (!saved) return;

    let extrasTotal = 0;
    const extrasArr = saved.extras || [];
    const extras = extrasArr.map((element) => {
      const extraCost = element.price * element.amount;
      extrasTotal += extraCost;
      return (
        <p key={`extra-${element.name}`} className="mb-0 small text-gray">
          {element.name} ({element.amount}): {extraCost.toFixed(2)} {this.props.priceUnit}
        </p>
      );
    });

    let zusaetzeTotal = 0;
    const zusArr = saved.selectedZusaetze || [];
    const zusaetze = zusArr.map((z) => {
      const cost = parseFloat(z.preis) || 0;
      zusaetzeTotal += cost;
      return (
        <p key={`zusatz-${z.id}`} className="mb-0 small text-gray">
          {z.name}: +{cost.toFixed(2)} {this.props.priceUnit}
        </p>
      );
    });

    const sizePrice = saved.selectedGroesse ? parseFloat(saved.selectedGroesse.preis) : null;
    const currentUnitPrice = (sizePrice != null && !isNaN(sizePrice)) ? sizePrice : (saved.price || this.props.price);
    const currentSizeLabel = saved.selectedGroesse
      ? `${saved.selectedGroesse.groesse || ''}${saved.selectedGroesse.einheit ? ' (' + saved.selectedGroesse.einheit + ')' : ''}`.trim()
      : null;

    this.setState({ extras, extrasTotal, zusaetze, zusaetzeTotal, currentUnitPrice, currentSizeLabel });
  }

  handleDelete = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (this.props.deleteFun) {
      this.props.deleteFun(this.props.product);
    }
  };

  render() {
    const displayName = formatProductDisplay(this.props.itemName, this.props.nummer);
    return (
      <div className="gold-members p-2 border-bottom">
        <div>
        <p className="text-gray mb-0 float-right ml-2 text-nowrap pr-1 text-right" style={{ width: "22%"}}>{this.getTotalPrice()} {this.props.priceUnit}</p></div>
        <div>
        <span className="count-number float-right d-inline-flex align-items-center">
          <Button
            variant="link"
            onClick={this.handleDelete}
            className="btn-sm p-0 mr-2 text-danger"
            title="Artikel entfernen"
            aria-label="Artikel entfernen"
          >
            <Icofont icon="trash" />
          </Button>
          <input className="count-number-input" type="text" value={this.state.quantity} readOnly/>
        </span>
        </div>
        <div className="media">
          {/* <div className="mr-2"><Icofont icon="circle" className="text-danger food-item" /></div> */}
          <div className="media-body">
            <p className="mt-1 mb-0 text-black">{displayName}</p>
            {this.state.currentSizeLabel ? (
              <p className="mb-0 small text-gray">Größe: {this.state.currentSizeLabel}</p>
            ) : ""}
          </div>
        </div>
        {this.state.zusaetze.length === 0 ? "" : <p className="text-gray mb-0 mt-1">Zusätze:</p>}
        {this.state.zusaetze}
        {this.state.extras.length === 0 ? "" : <p className="text-gray mb-0 mt-1">Extras:</p>}
        {this.state.extras}

      </div>
    );
  }
}

CheckoutItem.propTypes = {
  itemName: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  priceUnit: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  qty: PropTypes.number.isRequired,
  show: PropTypes.bool.isRequired,
  minValue: PropTypes.number,
  maxValue: PropTypes.number,
  getValue: PropTypes.func.isRequired,
  addFun: PropTypes.func.isRequired,
  removeFun: PropTypes.func.isRequired,
  deleteFun: PropTypes.func.isRequired,
  product: PropTypes.any.isRequired,
};

CheckoutItem.defaultProps = {
  show: true,
  priceUnit: '$'
};

export default CheckoutItem;
